import React, { useState, useEffect } from 'react';
import './Freizeitangebote.css';
import { host_url } from '../../../App'; // Import host_url
import { Link } from 'react-router-dom';
import { CiMap } from "react-icons/ci";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente


function Freizeitangebote() {
  const [offers, setOffers] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetch(`${host_url}/freizeitangebote`)
      .then(response => response.json())
      .then(data => {
        const sortedData = data.sort((a, b) => a.Name.localeCompare(b.Name));
        setOffers(sortedData);
      })
      .catch(error => console.error('Error fetching freizeitangebote details:', error));
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const filteredOffers = Array.isArray(offers) ? offers.filter(offer =>
    offer.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    offer.Beschreibung.toLowerCase().includes(searchTerm.toLowerCase())
  ) : [];

  return (
    <div className="freizeitangebote-container">
      <div className="page-header">
        <BackArrow to="/freizeit" />
        <h1>Freizeitangebote</h1>
      </div>
      <div className="filter-head">
        <div className="search-wrapper">
          <span className="material-symbols-outlined search-icon">search</span>
          <input
            type="text"
            placeholder="Durchsuchen..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      {filteredOffers.map((offer, index) => (
        <div key={index} className="offer-category">
          <div className={`offer-title ${activeIndex === index ? 'expanded' : ''}`} onClick={() => toggleAccordion(index)}>
            {offer.Name}
            <span className="material-symbols-outlined offer-arrow">
              {activeIndex === index ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
            </span>
          </div>
          <div className={`offer-details ${activeIndex === index ? 'expanded' : ''}`}>
            <p className="offer-description">{offer.Beschreibung}</p>
            <p className="offer-detail-item">
              <RiMoneyDollarCircleLine className="cost-icon"/>
              Kosten: {Math.floor(offer.Kosten)}
            </p>
            <Link
              to={`/stadtplan?offerId=${offer.ID}`}
              className="location-link"
            >
              <span className="material-symbols-outlined location-icon">map</span>
              <span className="location-label">Stadtplan</span>
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Freizeitangebote;
